import React, { useEffect, useState } from 'react';
import { LeftOutlined, FormOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Radio, Upload, message, DatePicker, Drawer } from 'antd';
import { useHistory } from 'troyfe';
import AnimationModal from '../../AnimationModal';
import ImgCrop from 'antd-img-crop';
import moment from 'moment';
import Block from './style';
import { imgUrlHandle } from '../../../utils/index';
import { DrawerStyle } from '../style';
import { UserApi } from "gmrfid-service-user-api-client";

function UserProfile({ userVisible, setUserVisible }) {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const history = useHistory();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imgList, setImgList] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const onClose = () => {
    setUserVisible(false);
  };
  useEffect(() => {
    UserApi.getUserInfoPC({}).then((res) => {
      if (res.status === 200) {
        const { mainRole } = res.data;
        form.setFieldsValue({
          ...res.data,
          birthday: res.data?.birthday ? moment(res.data?.birthday, 'YYYY-MM-DD') : '',
          createDate: res.data?.createDate ? res.data?.createDate.slice(0, 10) : '',
          mainRole: mainRole ? (mainRole === 'SUB_ADMIN' ? '主管理员' : '管理组') : '无',
        });
        setImgList([res.data?.headUrl]);
      }
    });
  }, []);
  const onFinish = (values) => {
    UserApi.updateUserInfoPC({
      form: {
        headUrl: imgList[0],
        sex: values.sex,
        userName: values.userName,
        birthday: (values?.birthday && values.birthday.format('YYYY-MM-DD HH:mm:ss.SSS')) || values?.birthday,
      },
    }).then((res) => {
      if (res.status === 200) {
        message.success('更改成功');
        setTimeout(() => {
          setUserVisible(false);
        }, 500);
        setDisabled(true);
      }
    });
  };
  const props = {
    name: 'file',
    action: '/api/gmrfid-service-common/admin/upload/upFile',
    headers: {
      Authorization: `Bearer ${userInfo.token}`,
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('文件格式或大小异常!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('上传文件大于2M,请重新选择');
      }
      return isJpgOrPng && isLt2M;
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        // console.log(info, info.file.response)
        setImgList([]);
        setImgList([info.file.response]);
        message.success(`${info.file.name} 上传成功`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 上传失败.`);
      }
    },
  };
  return (
    <Drawer
      title=""
      placement="right"
      size="large"
      onClose={onClose}
      visible={userVisible}
      className="drawerModal"
      destroyOnClose
    >
      <DrawerStyle>
        <div className="drawer-top">
          <h1>
            编辑资料
            <div className="clear" onClick={onClose}>
              x
            </div>
          </h1>
        </div>
        <Block>
          <div className="user-img">
            <div className="user-box">
              <p className="label">
                <i className="star">*</i>
                我的头像
              </p>
              <div className="img">
                <img src={imgList[0] ? imgUrlHandle(imgList[0]) : '/headPortrait.png'} alt="" />
                <div className="edit">
                  <ImgCrop
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Upload {...props}>
                      <FormOutlined style={{ color: '#fff', fontSize: 40, marginTop: 19 }} />
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </div>
          </div>
          <Form className="form" name="basic" form={form} onFinish={onFinish}>
            <Form.Item
              label="姓名"
              name="userName"
              rules={[
                {
                  required: true,
                  max: 20,
                  message: '请输入姓名（最多不超过20个字符）',
                },
              ]}
            >
              <Input placeholder="请输入姓名" disabled={disabled} />
            </Form.Item>
            <Form.Item
              label="性别"
              name="sex"
              rules={[
                {
                  required: false,
                  message: '请选择性别',
                },
              ]}
            >
              <Radio.Group disabled={disabled}>
                <Radio value="MAN">男</Radio>
                <Radio value="WOMAN" style={{ marginLeft: 100 }}>
                  女
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="手机号码" name="phone" rules={[]}>
              <Input placeholder="请输入姓名" disabled />
            </Form.Item>
            <Form.Item
              label="所属部门"
              name="deptName"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="当前职位"
              name="postName"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="权限管理"
              name="mainRole"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="出生日期"
              name="birthday"
              rules={[
                {
                  required: false,
                  message: '请选择',
                },
              ]}
            >
              <DatePicker disabled={disabled} placeholder="请选择" format="YYYY-MM-DD" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="加入日期"
              name="createDate"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Form>
          {isModalVisible && (
            <AnimationModal
              width={640}
              title="编辑头像"
              isFooter={false}
              closeCallback={() => {
                setIsModalVisible(false);
              }}
              confirmCallback={() => {}}
            >
              <div>
                <ImgCrop>
                  <Upload {...props}>
                    <PlusOutlined />
                    点击上传
                  </Upload>
                </ImgCrop>
                <div className="handle">
                  <Button
                    onClick={() => {
                      setIsModalVisible(false);
                    }}
                    className="cancel"
                  >
                    取消
                  </Button>
                  <Button className="confirm" type="primary" htmlType="submit">
                    保存
                  </Button>
                </div>
              </div>
            </AnimationModal>
          )}
        </Block>
        <div className="handle">
          {!disabled && (
            <>
              <Button
                onClick={() => {
                  onClose();
                }}
                className="cancel"
              >
                取消
              </Button>
              <Button
                className="confirm"
                type="primary"
                onClick={() => {
                  form.submit();
                }}
              >
                保存
              </Button>
            </>
          )}
        </div>
      </DrawerStyle>
    </Drawer>
  );
}

export default UserProfile;
